<template lang="pug">
section.visualizar-territorio
    .dados
        header
            h1
                i.el-icon-arrow-left.back(@click='goBack()')
                | {{ $t('mensagens.territorio.titulo') }}
        .mb2(v-if='territorio')
            p
                b {{ $t('mensagens.territorio.labels.nome') }}:
                |
                | {{ territorio.nome }}
            p
                b {{ $t('mensagens.territorio.labels.areaHa') }}:
                |
                | {{ formatNumber(territorio.areaHa) }}
            p
                b {{ $t('mensagens.territorio.labels.localidade') }}:
                |
                | {{ territorio.localidade }}
            p
                b {{ $t('mensagens.territorio.labels.dataCadastro') }}:
                |
                | {{ territorio.dataCadastroFormatada }}
            p(v-if='ff1183CodigoLyraTerritorio')
                b {{ $t('mensagens.territorio.labels.codigoLyra') }}:
                |
                | {{ territorio.codigoLyra }}

            hr

        el-collapse(
            v-model='collapseDadosTerritorioAtivo',
            @change='handleChangeCollapse',
            accordion
        )
            el-collapse-item(name='REPRESENTANTE')
                template(slot='title')
                    .titulo-collapse
                        i.flow.flow-user-second
                        |
                        | {{ $t('mensagens.territorio.representante.titulo') }}
                .container-dados-collapse
                    div(v-if='representantes.length')
                        .representante.mb2(
                            v-for='representante in representantes'
                        )
                            hr
                            p
                                b {{ $t('mensagens.territorio.representante.nome') }}:
                                |
                                | {{ representante.nomeRazaoSocial }}

                            p
                                b {{ $t('mensagens.territorio.representante.documento') }}:
                                |
                                | {{ numeralStringFormatTocpfCnpj(representante.cpfCnpj) }}

                            p
                                b {{ $t('mensagens.territorio.representante.papelPessoa') }}:
                                |
                                | {{ representante?.territorioPapelPessoa?.nome }}

                    .container-nenhum-resultado-collapse(v-else)
                        el-empty(:description='$t("mensagens.comuns.erros.nenhumResultadoEncontrado")')

            el-collapse-item(name='INFORMACAO_AGRICOLA')
                template(slot='title')
                    .titulo-collapse
                        i.flow.flow-planting
                        |
                        | {{ $t('mensagens.territorio.informacao.tituloPlural') }}
                .container-dados-collapse
                    div(v-if='informacoesAgricolas.length > 0')
                        .representante.mb2(
                            v-for='info in informacoesAgricolas'
                        )
                            hr
                            p
                                b {{ $t('mensagens.territorio.informacao.colheita') }}:
                                |
                                | {{ info?.cultura?.nome }}

                            p
                                b {{ $t('mensagens.territorio.informacao.areaPlantada') }}:
                                |
                                | {{ info?.areaPlantadaHa }}

                            p
                                b {{ $t('mensagens.territorio.informacao.produtividadeMedia') }}:
                                |
                                | {{ info?.produtividade }}
                        
                    .container-nenhum-resultado-collapse(v-else)
                        el-empty(:description='$t("mensagens.comuns.erros.nenhumResultadoEncontrado")')

            el-collapse-item(
                v-if='territorio && territorio.diagnosticoSocioambiental !== null',
                name='DIAGNOSTICO',
                v-model="childCollapse",
            )
                template(slot='title')
                    .titulo-collapse
                        i.mdi.mdi-clipboard-pulse-outline
                        |
                        | {{ $t('mensagens.territorio.diagnosticoSocioambiental') }}

                .container-dados-collapse
                    div(v-if='diagnosticoSocioambientalTerritorio')
                    el-collapse(
                        v-model="childCollapse",
                        accordion,
                        @change='fecharCollapseFilhos',
                    )
                        el-collapse-item(
                            name='DIAGNOSTICO_SOCIOAMBIENTAL',
                        )
                            template(slot='title')
                                .titulo-collapse
                                    i.mdi.mdi-clipboard-pulse-outline
                                    |
                                    | {{ $t('mensagens.territorio.titulo') }}
                            .container-dados-collapse
                                DiagnosticoSocioambiental(
                                    v-if='refMapa',
                                    :dadosConsulta='diagnosticoSocioambientalTerritorio',
                                    @index-aberto='mostrarRestricaoTerritorio',
                                    :fecharCollapses='true',
                                    :mapaLeaflet='refMapa',
                                    :habilitar-zoom-restricao='true'
                                )

                            div(v-if='diagnosticoRepresentante && diagnosticoRepresentante.diagnostico && diagnosticoRepresentante.diagnostico[0].diagnostico.length > 0')
                                div(v-for='representantes in diagnosticoRepresentante')
                                    el-collapse(
                                        accordion,
                                        @change='fecharCollapseFilhos',
                                    )
                                        el-collapse-item(
                                            name='DIAGNOSTICO_SOCIOAMBIENTAL_REPRESENTATES',
                                            before-enter
                                        )
                                            template(slot='title')
                                                .subtitulo-collapse
                                                    i.flow.flow-user-second.mr-2
                                                    |
                                                    | {{ $t('mensagens.territorio.representante.titulo') }}
                                            .container-dados-collapse
                                                el-collapse(
                                                    accordion,
                                                    @change='fecharCollapseFilhos',
                                                )
                                                    el-collapse-item(
                                                        v-for='(representante, index) in representantes',
                                                        :name='index'
                                                    )

                                                        template(slot='title')
                                                            .subtitulo-collapse
                                                                i.flow.flow-user-second.mr-2
                                                                |
                                                                | {{ representante.nomeRepresentante }} - {{ representante.documento }}
                                                        .container-dados-collapse
                                                            DiagnosticoSocioambiental(
                                                                v-if='refMapa',
                                                                :dadosConsulta='representante',
                                                                :cpfCnpj='representante.documento',
                                                                @index-aberto='atualizarRestricaoMapaCpf',
                                                                :fecharCollapses='true',
                                                                :mapaLeaflet='refMapa',
                                                                :habilitar-zoom-restricao='true'
                                                            )

    mapa.mapa(
        :mapLayersConfigs='layersMaps',
        :mapConfig='mapConfig',
        :height='"100%"',
        :idMapa='"mapaTerritorio"',
        ref='mapa',
        :atualizarMapa='true',
        :menuMaior='true'
    )
</template>

<script>
import territorioService from '@/services/TerritorioService';
import Mapa from '@/components/MapaLeaflet.vue';
import formatters from '@/utils/formatters';
import { getEstiloGeometria } from '@/utils/mapa/mapa.estilos';
import { mapState } from 'vuex';
import DiagnosticoSocioambientalService from '@/services/DiagnosticoSocioambientalService';
import DiagnosticoSocioambiental from '@/components/diagnosticoSocioambiental/index.vue';
import L from 'leaflet';
import centroidFromGeoJSON from '@/utils/centroidFromGeoJSON';
import EventBus from '@/utils/eventBus';
import { formatFlag } from '@/utils/featureFlags/featureFlag';
import { FeatureFlagConst } from '@/constants/FeatureFlag';

export default {
    name: 'VisualizarTerritorioParaguai',
    components: {
        Mapa,
        DiagnosticoSocioambiental
    },
    data() {
        return {
            idTerritorio: this.$route.params.idTerritorio,
            territorio: null,
            representantes: [],
            informacoesAgricolas: [],
            layersMaps: [],
            mapConfig: {
                controls: {
                    zoomControl: true,
                    camadasControl: true,
                    fullscreen: true,
                    buscarCarControl: false
                },
                inspecionar: true
            },
            historicos: [],
            collapseDadosTerritorioAtivo: '',
            diagnosticoSocioambientalTerritorio: null,
            diagnosticoRepresentante: null,
            diagnosticoCar: null,
            refMapa: null,
            childCollapse: [],
            ff1183CodigoLyraTerritorio: this.$unleash.isEnabled(formatFlag(FeatureFlagConst.FF1183_CODIGO_LYRA_TERRITORIO))
        };
    },
    computed: {
        ...mapState(['usuarioLogado'])
    },
    async mounted() {
        await this.fetchTerritorio();
        this.refMapa = this.$refs.mapa;
    },
    methods: {
        async fetchTerritorio() {
            const { data } = await territorioService.findById(
                this.idTerritorio
            );
            this.territorio = data;
            this.representantes = this.territorio.representantes;
            if (this.territorio.informacoesAgricolas != null) {
                this.informacoesAgricolas = this.territorio.informacoesAgricolas;
                this.informacoesAgricolas.forEach(ia => {
                    ia.produtividade = formatters.formatNumber(ia.produtividade);
                    ia.areaPlantadaHa = formatters.formatNumber(ia.areaPlantadaHa);
                });
            }
            this.configureLayersMapa();
        },
        configureLayersMapa() {
            this.layersMaps = [];

            let layerTerritorio = {
                style: getEstiloGeometria('area'),
                name: this.$t('mensagens.territorio.titulo'),
                geoJson: this.territorio.geometria
            };

            this.layersMaps.push(layerTerritorio);
        },
        numeralStringFormatTocpfCnpj(valor) {
            return formatters.numeralStringFormatToDocumento(valor);
        },
        formatNumber(number) {
            return number
                ? Number(number).toLocaleString('pt-br', {
                      minimumFractionDigits: 4
                  })
                : '-';
        },
        goBack() {
            this.$router.go(-1);
        },
        async handleChangeCollapse() {
            if (this.collapseDadosTerritorioAtivo === 'DIAGNOSTICO') {
                this.childCollapse = [];
                EventBus.$emit('fecharCollapses');
                await this.buscarDiagnosticoSocioambiental();
            }
        },

        fecharCollapseFilhos() {
            EventBus.$emit('fecharCollapses');
        },

        async buscarDiagnosticoSocioambiental() {
            const { data } = await DiagnosticoSocioambientalService.buscarPorId(
                JSON.stringify(this.territorio.diagnosticoSocioambiental.id)
            );
            this.diagnosticoSocioambientalTerritorio = {
                diagnostico: JSON.parse(data.resultado),
                protocoloDescricao: data.protocoloDescricao
            };

            this.diagnosticoRepresentante = {
                diagnostico: JSON.parse(data.resultadoRepresentante)
            };

            this.diagnosticoCar = {
                diagnostico: JSON.parse(data.resultadoCar)
            };
            
            this.$notify.info({
                message: this.$t('mensagens.territorio.diagnosticoRealizadoNoMomentoDoCadastro')
            });
        },

        mostrarRestricaoTerritorio(_, indexCollapse, indexCamada) {
            this.layersMaps = [];

            this.layersMaps.push({
                style: getEstiloGeometria('area'),
                name: this.$t('mensagens.territorio.titulo'),
                geoJson: this.territorio.geometria
            });

            if (indexCamada) {
                this.diagnosticoSocioambientalTerritorio.diagnostico[
                    indexCamada
                ].resultados.forEach((restricao, index) => {
                    const geometria = restricao.geometria || restricao.geometry;

                    if (geometria) {
                        const pin = L.icon({
                            iconUrl: 'https://lyra-v1.s3.amazonaws.com/Pin+da+restricao.png',
                            iconSize: [18, 18]
                        });

                        this.layersMaps.push({
                            name: `CentroidDiagnostico_${index}_${indexCollapse}`,
                            icon: pin,
                            geoJson: centroidFromGeoJSON.get(geometria)
                        });
                    }

                    this.layersMaps.push({
                        style: getEstiloGeometria('restricao'),
                        name: `restricaoTerritorio_${indexCamada}_${index}`,
                        geoJson: restricao.geometry
                    });
                });
            }
        },

        atualizarRestricaoMapaCpf(restricao, indexCollapse, indexCollapseRow) {
            this.areasRestricao = [];

            const indexTagRemove =
                this.indexUltimaRestricaoAbertaRepresentante != null
                    ? this.indexUltimaRestricaoAbertaRepresentante
                    : indexCollapseRow;
            const tagRestricaoRemove = `${indexCollapse}-representante-${indexTagRemove}`;
            this.layersMaps = this.layersMaps.filter(
                l => l.tagRestricao !== tagRestricaoRemove
            );

            if (indexCollapseRow !== '' && this.diagnosticoRepresentante[indexCollapse]) {
                this.indexUltimaRestricaoAbertaRepresentante = indexCollapseRow;

                if (
                    this.diagnosticoRepresentante[indexCollapse].diagnostico[
                        indexCollapseRow
                    ]
                ) {
                    this.areasRestricao = {
                        areas: this.diagnosticoRepresentante[indexCollapse].diagnostico[
                            indexCollapseRow
                        ].resultados.map(
                            resultado =>
                                resultado.geometria || resultado.geometry
                        ),
                        camada: this.diagnosticoRepresentante[indexCollapse].diagnostico[
                            indexCollapseRow
                        ].camada
                    };
                }

                const tagRestricaoAdd = `${indexCollapse}-representante-${indexCollapseRow}`;
                const group = `grupo-restricoes-${indexCollapse}-${indexCollapseRow}`;
                this.mostrarAreasDiagnosticoNoMapa(
                    tagRestricaoAdd,
                    group,
                    restricao
                );
            }
        },

        atualizarRestricaoMapaCars(restricao, indexCollapse, indexCollapseRow) {
            this.areasRestricao = [];
            
            const indexTagRemove =
                this.indexUltimaRestricaoAbertaCar !== null
                    ? this.indexUltimaRestricaoAbertaCar
                    : indexCollapseRow;

            const tagRestricaoRemove = `${indexCollapse}-car-${indexTagRemove}`;
            this.layersMaps = this.layersMaps.filter(
                l => l.tagRestricao !== tagRestricaoRemove
            );
            if (indexCollapseRow !== '') {
                this.indexUltimaRestricaoAbertaCar = indexCollapseRow;
                if (
                    this.diagnosticoCar.diagnostico[indexCollapse].diagnosticos[indexCollapseRow]
                ) {
                    this.areasRestricao = {
                        areas: this.diagnosticoCar.diagnostico[indexCollapse].diagnosticos[
                            indexCollapseRow
                        ].resultados.map(
                            resultado =>
                                resultado.geometria || resultado.geometry
                        ),
                        camada: this.diagnosticoCar.diagnostico[indexCollapse].diagnosticos[
                            indexCollapseRow
                        ].camada
                    };
                }

                const tagRestricaoAdd = `${indexCollapse}-car-${indexCollapseRow}`;
                const group = `grupo-restricoes-${indexCollapse}-${indexCollapseRow}`;
                this.mostrarAreasDiagnosticoNoMapa(
                    tagRestricaoAdd,
                    group,
                    restricao
                );
            }
        },

        mostrarAreasDiagnosticoNoMapa(tagRestricao, group, restricao) {
            const opacidade =
                this.areasRestricao.camada.opacidade >= 0.0
                    ? this.areasRestricao.camada.opacidade / 200
                    : 0.5;

            this.areasRestricao.areas.forEach((area, index) => {
                this.layersMaps.push({
                    style: {
                        color: 'red',
                        weight: 1,
                        fill: true,
                        opacity: opacidade,
                        fillOpacity: opacidade
                    },
                    name: `AreaDiagnostico ${index}`,
                    tagRestricao,
                    group,
                    geoJson: area
                });

                const pin = L.icon({
                    iconUrl: 'https://lyra-v1.s3.amazonaws.com/Pin+da+restricao.png',
                    iconSize: [18, 18]
                });

                this.layersMaps.push({
                    name: `CentroidDiagnostico ${index}`,
                    icon: pin,
                    tagRestricao,
                    group,
                    geoJson: centroidFromGeoJSON.get(area)
                });
            });
        }

    }
};
</script>

<style lang="scss">
.visualizar-territorio {
    padding: 20px;
    height: 100%;
    width: 100%;
    display: flex;
}

header {
    grid-area: header;
    margin-bottom: 30px;

    h1 {
        line-height: 1;
    }
}

.espacamento-historico {
    height: auto;
}

.dados {
    width: 600px;
    background-color: var(--white);

    padding: 16px;
    border-radius: 5px 0 0 5px;

    overflow: auto;

    .mb1 {
        margin-bottom: 15px;
        margin-top: 20px;
    }

    .mb2 {
        margin-bottom: 32px;
    }

    p {
        line-height: 1.5;
    }

    h2 {
        margin-left: 15px;
    }

    h3 {
        margin-left: 30px;
    }

    .el-collapse-item__content {
        padding-bottom: 0 !important;
    }
}

.mapa {
    grid-area: mapa;
    width: 100%;
    border-radius: 0 5px 5px 0;
    overflow: hidden;
}

.back {
    cursor: pointer;
    line-height: 2;
}

.titulo-collapse {
    font-size: 18px;
    font-weight: normal;
}

.subtitulo-collapse {
    font-size: 16px;
    font-weight: normal;
}

.container-dados-collapse {
    margin-left: 12px;
}

.container-nenhum-resultado-collapse {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    i {
        color: var(--gray-light);
        font-size: 30px;
    }
}

#tabelas-collapse {
    font-size: 14px;
    color: var(--primary-font-color);

    tr:nth-child(odd) {
        background-color: var(--selected-background-color);
    }
}

#tabelas-collapse > div.el-table__header-wrapper > table > thead > tr > th {
    font-weight: 500 !important;
    font-size: 14px !important;
    color: var(--primary-font-color) !important;
}

#tabelas-collapse
    > div.el-table__body-wrapper.is-scrolling-none
    > table
    > tbody
    > tr
    > td {
    border: none !important;
}

#tabelas-collapse
    > div.el-table__body-wrapper.is-scrolling-none
    > table
    > tbody
    > tr
    > td
    > .cell
    > span {
    word-break: break-word;
}

#tabelas-collapse > div.el-table__header-wrapper > table > thead > tr > th {
    border: none !important;
}

.text-align-right {
    text-align: right;
}

.item-list-row {
    display: grid;
    grid-template-columns: auto auto auto;
    width: 100%;
    column-gap: 10px;
}

.custom-divider {
    margin-bottom: 1px !important;
    margin-top: -12px !important;
}
</style>
